

import * as React from 'react';

import { CiriumModal } from './CiriumModal';
import { Flex, Button, Text } from '@flightstats/airframe-react';

export type ErrorModalProps = {
  showModal: boolean,
  closeModal: () => void,
  title: string,
  errors: Array<string>,
};

export const ErrorModal = ({
  showModal,
  closeModal,
  title,
  errors,
}: ErrorModalProps) => {
  if (!errors || !errors.join) {
    //send a backup trace since this has already failed once w/o useful info
    console.error({ who: 'ErrorModal', errors });
  }
  const message = errors.join('; ');
  return (
    <CiriumModal showModal={showModal} closeModal={closeModal} title={title}>
      <Flex className='cirium-modal-flex'>
        <Text className='cirium-modal-flex-text' bold>
          {message}
        </Text>
        <Button className='cirium-modal-flex-button' onClick={closeModal}>
          OK
        </Button>
      </Flex>
    </CiriumModal>
  );
};
